import * as config from "./config";
import type { EventDispatcherOptions } from "../typings";
import { HOUSTON_URL_TEMPLATE } from "./config";

export const sharedDefaultOptions: EventDispatcherOptions = {
  collectorDomain: config.COLLECTOR_DOMAIN,
  collectorPath: "",
  urlTemplates: HOUSTON_URL_TEMPLATE,
  deployStage: config.DEFAULT_DEPLOY_STAGE,
  eventModifier: (event) => event,
  logger: () => {
    // no-op
  },
  userIdPrefix: "",
};
